import * as React from "react";
import { useState } from "react";
import * as tokenService from "../../services/tokenService";
import { useTranslation } from "react-i18next";
import { cultureCodeEnglish, cultureCodeFinnish, cultureCodeSwedish } from "../../models/common/consts";
import fiFlag from "flag-icons/flags/4x3/fi.svg";
import gbFlag from "flag-icons/flags/4x3/gb.svg";
import seFlag from "flag-icons/flags/4x3/se.svg";

export interface ILoginPageProp {
    onLogin: (username: string, password: string) => void;
    onLogout: () => void;
}

export const LoginPage = ({ onLogin }: ILoginPageProp) => {
    const { t, i18n } = useTranslation();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (username && password) {
            tokenService.logout().then(() => {
                onLogin(username, password);
            });
        }
    };

    const currentLang = i18n.language?.startsWith("fi")
        ? cultureCodeFinnish
        : i18n.language?.startsWith("sv")
            ? cultureCodeSwedish
            : cultureCodeEnglish;

    return (
        <div className="loginPage">
            <div className="loginImage" style={{ backgroundImage: "url(" + appConfig.ownRoot + "ImageLogin-EasyOpp.jpg)" }} />
            <div className="loginForm">
                <div className="login-wrapper">
                    {!!appConfig.environmentName &&
                        <div className="environmentName" style={{ backgroundColor: appConfig.environmentColor }}>{appConfig.environmentName}</div>
                    }
                    <div className="loginLogo">
                        <img
                            src={appConfig.ownRoot + "EasyOpp.svg"}
                            alt="EasyOpp - Decorative logo"
                            style={{ height: 72 }}
                        />
                    </div>
                    <div className="loginContainer">
                        <form name="loginForm" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input className="form-control" id="UserName" name="username" placeholder={t("common.username")} value={username} type="text" autoComplete="username" onChange={(e) => setUsername(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <input className="form-control" name="password" placeholder={t("common.password")} value={password} type="password" autoComplete="current-password" onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            <div className="form-group" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div id="loginLanguageSelect" style={{ display: "flex", gap: "4px" }}>
                                    {([
                                        { code: cultureCodeFinnish, src: fiFlag, label: t("common.languageFinnish") },
                                        { code: cultureCodeEnglish, src: gbFlag, label: t("common.languageEnglish") },
                                        { code: cultureCodeSwedish, src: seFlag, label: t("common.languageSwedish") },
                                    ] as const).map(({ code, src, label }) => (
                                        <button
                                            key={code}
                                            type="button"
                                            title={label}
                                            aria-label={label}
                                            aria-pressed={currentLang === code}
                                            onClick={() => void i18n.changeLanguage(code)}
                                            style={{
                                                background: "transparent",
                                                border: `2px solid ${currentLang === code ? "#bbbec0" : "transparent"}`,
                                                borderRadius: "6px",
                                                padding: "2px 4px",
                                                cursor: "pointer",
                                                lineHeight: 1,
                                                opacity: currentLang === code ? 1 : 0.45,
                                            }}
                                        >
                                            <img src={src} alt={label} width={28} height={21} style={{ display: "block" }} />
                                        </button>
                                    ))}
                                </div>
                                <input className="btn btn-primary loginButton" type="submit" value={t("signIn")} />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
